export const handleAspectRatio = (aspectRatio) => {
  switch (aspectRatio) {
    case 'SQUARE':
      return { width: 600, height: 450 };
    case 'WIDESCREEN':
      return { width: 720, height: 405 };
    case 'VERTICAL':
      return { width: 405, height: 720 };
    default: return { width: 600, height: 450 };
  }
}

export const aspectRatioRercent = (aspectRatio) => {
  switch (aspectRatio) {
    case 'SQUARE':
      return '4/3';
    case 'WIDESCREEN':
      return '16/9';
    case 'VERTICAL':
      return '9/16';
    default: return '4/3';
  }
}

export const parseParamsToQueryString = (params) => {
  const q = new URLSearchParams()
  Object.keys(params).forEach((key) => {
    if (params[key] instanceof Array) {
      params[key].forEach((value) => q.append(key, value))
    } else if (params[key]) {
      q.append(key, params[key])
    }
  })
  return q
}

export const parseQueryStringToParams = (data) => {
  if(!data) return
  
  const params = new URLSearchParams(data);
  const result = {};
  params.forEach((value, key) => {
    if (key === "user") {
      result[key] = JSON.parse(decodeURIComponent(value));
    } else {
      result[key] = decodeURIComponent(value);
    }
  });

  return result
}

export const formatNumber = (value) => {
  if (value === null || value === undefined || isNaN(Number(value))) {
    return '0';
  }

  const numValue = Number(value);
  
  if (Math.abs(numValue) < 0.000001 && numValue !== 0) {
    return numValue.toFixed(20).replace(/\.?0+$/, '');
  }

  const stringValue = String(numValue);
  const parts = stringValue.split('.');
  
  // Format phần nguyên với dấu phẩy ngăn cách hàng nghìn
  const integerPart = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  
  if (parts.length === 1) return integerPart;
  
  // Xử lý phần thập phân
  const trimmedDecimal = parts[1].replace(/0+$/, '');
  if (!trimmedDecimal) return integerPart;
  
  return `${integerPart}.${trimmedDecimal}`;
};
